<template>
    <div class="component-myDialog">
        <van-dialog
            v-model:show="dialogVisible"
            title="长按保存到手机相册"
            theme="round-button"
            confirmButtonText="关闭"
            confirmButtonColor="#007AFF"
        >
            <div class="dialog-content">
                <PosterGenerator
                    v-if="data.title"
                    bgImage="https://p5.ssl.qhimg.com/t110b9a930194bc7d7c86c1bad4.png"
                    title="我刚刚向 ISC.AI 2026 提交了议题："
                    :subtitle="data.title"
                    :descList="desc"
                    :avatar="data.avatar"
                    :nickname="data.name"
                    qrCode="https://p0.ssl.qhimg.com/t110b9a93010fea8cfd79bde8e9.png"
                />
            </div>
        </van-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import PosterGenerator from './posterGenerator.vue'

const props = defineProps({
    data: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const desc = [
  '期待与你，一起加入这场定义未来的对话。',
  '',
  '扫码提交议题',
  '生成你的专属思想海报，100%有奖！'
]

let dialogVisible = ref(false)

const openModel = () => {
    dialogVisible.value = true
}

const closeModel = () => {
    dialogVisible.value = false
}

// const onError = (image) => {
//     props.images.splice(props.images.indexOf(image), 1)
// }

defineExpose({ // 导出方法
    openModel,
    closeModel
});

</script>

<style lang="scss" scoped>
.component-myDialog{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .dialog-content{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 8px 12px 20px;
        margin-bottom: 8px;
        .poster-img{
            width: 100%;
            border-radius: 4px; 
            z-index: 10;
            border: 1px solid #dedcdc;
        }
    }
    :deep(.van-swipe__indicator){
        background-color: #606266;
    }
    :deep(.van-swipe__indicator--active){
        background-color: #1989fa;
    }
    :deep(.van-dialog--round-button .van-dialog__footer){
        padding: 4px 24px 12px;
    }
    :deep(.van-dialog__header){
        padding-top: 12px;
    }
    :deep(.van-dialog){
        border-radius: 10px;
    }
}
</style>